module.exports = __webpack_public_path__ + "static/water_optimos1-ff6d4fc01269cbd5135b2e615bc4423e.jpg";